import React from 'react';
import PropTypes from 'prop-types';

import { KeyboardDatePicker as MUIKeyboardDatePicker } from '@material-ui/pickers';

export const KeyboardDatePicker = props => <MUIKeyboardDatePicker {...props} />;

KeyboardDatePicker.propTypes = {
  DialogProps: PropTypes.object,
  KeyboardButtonProps: PropTypes.object,
  autoOk: PropTypes.bool,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  format: PropTypes.string,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.node,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  keyboardIcon: PropTypes.node,
  label: PropTypes.node,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  onAccept: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.object
};

export default KeyboardDatePicker;
